module.exports = __webpack_public_path__ + "static/media/dress-code-women2.53701e70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dressCode/dress-code-women2.jpg
// module id = 703
// module chunks = 0